import React from 'react';

import styled from 'styled-components';

import ContentContainer from 'components/ContentContainer/ContentContainer';
import CountdownCard from 'components/ModularBlocks/AnimatedCards/Components/CountdownCard';
import CtaSection from 'components/ModularBlocks/AnimatedCards/Components/CtaSection';

import { AnimatedCardsI } from 'interfaces/content-stack/modular-blocks/animatedCards';

export interface AnimatedCardsProps {
  data: AnimatedCardsI;
  className: string;
}

const OuterContainer = styled(ContentContainer)`
  .inner-container {
    gap: 2rem;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid;
    padding-top: 8rem;
    padding-bottom: 8rem;

    @media screen and (max-width: ${(props) => props.theme.breakpoints.lg}) {
      padding-top: 6rem;
      padding-bottom: 6rem;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints.md}) {
      padding-top: 4rem;
      padding-bottom: 4rem;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints.xs}) {
      padding-top: 3rem;
      padding-bottom: 3rem;
    }
  }
`;

const CardsContainer = styled.div`
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  display: grid;

  @media screen and (max-width: ${(props) => props.theme.breakpoints.lg}) {
    grid-area: span 1 / span 2 / span 1 / span 2;
  }
`;

const AnimatedCards: React.FC<AnimatedCardsProps> = ({ data, className }) => {
  const blockReference = data?.blockReference ? data.blockReference[0] : undefined;

  return (
    <OuterContainer className={className}>
      {blockReference?.ctaSection && <CtaSection data={blockReference.ctaSection} />}
      <CardsContainer>
        {blockReference?.animatedCards?.map((card, index) => <CountdownCard card={card} key={index} />)}
      </CardsContainer>
    </OuterContainer>
  );
};

export default AnimatedCards;
